export const INITIAL_COLUMNS = [
  'Campanha',
  'Descrição',
  'Data Execução',
  'Entregues',
  'Lidas',
  'Não confirmadas',
  'Em espera',
  'Desconhecidas',
  'Falhas',
  'Total',
];

export const SENT_MESSAGES_COLUMN_ORDER = [
  'Título da campanha',
  'Data de envio',
  'Modelo da mensagem',
  'Contato destinatário',
  'Último Status',
  'Tipo de canal',
  'Data de início da campanha',
  'Data de fim da campanha',
  'ID campanha enviada',
  'ID da Mensagem',
  'Ordem da mensagem',
  'Banco',
  'Código de Barras',
  'Contrato ID',
  'CPF/CNPJ',
  'Data de Vencimento',
  'ID da Fatura',
  'Nome Completo',
  'Referência 01',
  'Referência 02',
  'Referência 03',
  'Referência 04',
  'Referência 05',
  'Valor Total',
  'WhatsApp',
];

export const MODE_GRAPHIC_ROWS_PER_PAGE = 100;
